"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionSelect = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const classnames_1 = __importDefault(require("classnames"));
const action_select_styles_1 = require("./action-select.styles");
const localization_1 = require("../../../localization");
const ActionSelect = ({ options, label, isDisabled, onSelect, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [menuAnchorEl, setMenuAnchorEl] = (0, react_1.useState)(null);
    const isOpen = !!menuAnchorEl;
    const handleActionClick = (e) => setMenuAnchorEl(e.currentTarget);
    const handleClose = () => setMenuAnchorEl(null);
    const handleItemClick = (id) => {
        handleClose();
        onSelect(id);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(action_select_styles_1.StyledAction, { rounded: true, variant: "outlined", color: "primary", title: label, size: "small", disabled: isDisabled, className: (0, classnames_1.default)({ 'menu--open': isOpen }), endIcon: react_1.default.createElement(ui_components_1.Icon, { variant: isOpen ? 'chevronUp' : 'chevronDown' }), onClick: handleActionClick }), react_1.default.createElement(action_select_styles_1.StyledMenu, { keepMounted: true, anchorEl: menuAnchorEl, open: isOpen, onClose: handleClose, elevation: 0, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
        } }, react_1.default.createElement(action_select_styles_1.StyledMenuContentWrapper, null, options.map(({ value, label }) => (react_1.default.createElement(ui_components_1.MenuItem, { key: value, onClick: () => handleItemClick(value) }, t({ key: label }))))))));
};
exports.ActionSelect = ActionSelect;
exports.default = exports.ActionSelect;
